export function capitalizeFirstLetter(str) {
  if (typeof str !== "string") return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function addPeriodToSentence(str) {
  if (typeof str !== "string") return str;
  return str.substr(-1) !== "." ? `${str}.` : str;
}

export function formatSentence(str) {
  if (typeof str !== "string") return str;
  return capitalizeFirstLetter(addPeriodToSentence(str));
}
